import { formatMoney } from '@/utils/format';
import type { BulkChannel, FundingWallet } from '@/types/portal';

interface SourceWalletPanelProps {
  wallets: FundingWallet[];
  walletId: string;
  onWallet: (id: string) => void;
  channel: BulkChannel;
  onChannel: (channel: BulkChannel) => void;
  currency: string;
  balance: number;
}

const CHANNELS: { id: BulkChannel; label: string }[] = [
  { id: 'wallet', label: 'Wallet-to-Wallet transfers' },
  { id: 'mobile', label: 'Mobile Money (M-Pesa / Airtel)' },
];

const selectClass =
  'h-10 w-full rounded-md border border-background-300 bg-background-50 px-3 text-sm text-foreground-800 focus:border-primary-400 focus:outline-none cursor-pointer';

export default function SourceWalletPanel({
  wallets,
  walletId,
  onWallet,
  channel,
  onChannel,
  currency,
  balance,
}: SourceWalletPanelProps) {
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
      <div>
        <label htmlFor="bulk-source" className="text-xs font-label font-medium text-foreground-600">
          From Wallet <span className="text-primary-600">*</span>
        </label>
        <select
          id="bulk-source"
          value={walletId}
          onChange={(event) => onWallet(event.target.value)}
          className={`mt-1.5 ${selectClass}`}
        >
          <option value="">Select source wallet...</option>
          {wallets.map((wallet) => (
            <option key={wallet.id} value={wallet.id}>
              {wallet.currency} float · {formatMoney(wallet.balance, wallet.currency)}
            </option>
          ))}
        </select>
        <p className="mt-1.5 text-xs text-foreground-500">
          Balance:{' '}
          <span className="font-medium text-foreground-800">
            {walletId ? formatMoney(balance, currency) : '—'}
          </span>
        </p>
      </div>

      <div>
        <label htmlFor="bulk-channel" className="text-xs font-label font-medium text-foreground-600">
          Transaction Type <span className="text-primary-600">*</span>
        </label>
        <select
          id="bulk-channel"
          value={channel}
          onChange={(event) => onChannel(event.target.value as BulkChannel)}
          className={`mt-1.5 ${selectClass}`}
        >
          {CHANNELS.map((item) => (
            <option key={item.id} value={item.id}>
              {item.label}
            </option>
          ))}
        </select>
        <p className="mt-1.5 text-xs text-foreground-500">
          One channel applies to every recipient in this batch.
        </p>
      </div>
    </div>
  );
}